var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.initialLoading ? _c('div', [_c('v-row', [_c('v-col', [_c('v-skeleton-loader', {
    attrs: {
      "type": "table"
    }
  })], 1)], 1)], 1) : _c('DatatableWrapper', {
    attrs: {
      "loading": _vm.feedbackLoading,
      "pagination": _vm.pagination,
      "title": _vm.title,
      "clickable-row": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "expanded": _vm.latestExpand,
      "headers": _vm.feedbackHeader,
      "items": _vm.sessionFeedback,
      "loading": _vm.feedbackLoading,
      "disable-sort": "",
      "mobile-breakpoint": "0",
      "hide-default-footer": "",
      "single-expand": ""
    },
    on: {
      "update:expanded": function updateExpanded($event) {
        _vm.latestExpand = $event;
      },
      "click:row": _vm.handleNavigation
    },
    scopedSlots: _vm._u([{
      key: "item.session",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', {
          staticClass: "font-weight-bold text-uppercase"
        }, [_vm._v(_vm._s(item.session_id))])];
      }
    }, {
      key: "item.user",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('user-avatar', {
          attrs: {
            "user-detail": item.user
          }
        })];
      }
    }, {
      key: "item.message",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s((item === null || item === void 0 ? void 0 : item.message) || "No message") + " ")];
      }
    }, {
      key: "item.country",
      fn: function fn(_ref4) {
        var _item$country;
        var item = _ref4.item;
        return [item !== null && item !== void 0 && (_item$country = item.country) !== null && _item$country !== void 0 && _item$country.city ? _c('country-city', {
          attrs: {
            "detail": item.country
          }
        }) : _vm._e()];
      }
    }, {
      key: "item.feedback",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [item.message ? _c('MaxText', {
          attrs: {
            "text": item.message,
            "max": "100"
          }
        }) : _c('empty')];
      }
    }, {
      key: "item.device",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('device', {
          attrs: {
            "device": item.device
          }
        })];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref8) {
              var on = _ref8.on;
              return [_c('span', _vm._g({}, on), [_c('v-icon', {
                attrs: {
                  "color": _vm.$options.STATUS[item.status].color
                }
              }, [_vm._v(_vm._s(_vm.$options.STATUS[item.status].icon))])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(" " + _vm._s(_vm.$options.STATUS[item.status].title) + " ")])])];
      }
    }, {
      key: "item.attachments",
      fn: function fn(_ref9) {
        var _item$stats$attachmen, _item$stats;
        var item = _ref9.item;
        return [_c('flex-row', {
          attrs: {
            "gap": "4px",
            "justify": "center"
          }
        }, [_c('v-icon', [_vm._v("mdi-attachment")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")((_item$stats$attachmen = item === null || item === void 0 ? void 0 : (_item$stats = item.stats) === null || _item$stats === void 0 ? void 0 : _item$stats.attachments) !== null && _item$stats$attachmen !== void 0 ? _item$stats$attachmen : 0)))])], 1)];
      }
    }, {
      key: "item.created_at",
      fn: function fn(_ref0) {
        var item = _ref0.item;
        return [_c('vue-hoverable-date', {
          attrs: {
            "date": item.created_at
          }
        })];
      }
    }, {
      key: "item.navigate",
      fn: function fn(_ref1) {
        var item = _ref1.item;
        return [_c('div', {
          staticClass: "flex-row jc-c"
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.handleNavigation(item);
            }
          }
        }, [_c('i', {
          staticClass: "arrow-right"
        })])], 1)];
      }
    }])
  })], 1), _c('Modal', {
    attrs: {
      "width": "100%"
    },
    on: {
      "close": function close($event) {
        _vm.singleFeedbackDetailModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('single-feedback-detail', {
          attrs: {
            "feedback-detail": _vm.feedbackDetail
          },
          on: {
            "close": function close($event) {
              _vm.singleFeedbackDetailModal = false;
            },
            "update-attachment": _vm.updateAttachmentPage,
            "confirm-delete-attachment": _vm.onConfirmDeleteAttachment,
            "delete-dialog": _vm.openDeleteDialog,
            "update-feedback": _vm.openUpdateFeedback,
            "update-status": _vm.updateStatus,
            "open-flagging": _vm.openFlagging,
            "feedback-update-dialog": _vm.feedbackUpdateDialog
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.singleFeedbackDetailModal,
      callback: function callback($$v) {
        _vm.singleFeedbackDetailModal = $$v;
      },
      expression: "singleFeedbackDetailModal"
    }
  }), _c('Modal', {
    on: {
      "close": function close($event) {
        _vm.openUpdateFeedbackForm = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function fn() {
        return [_c('v-row', [_c('v-col', {
          staticClass: "mt-4 font-size-h3 bold-text",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Update feedback message ")]), _c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-textarea', _vm._b({
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: 'max:600',
            expression: "'max:600'"
          }],
          attrs: {
            "auto-grow": "",
            "counter": "600",
            "filled": "",
            "hide-details": "auto",
            "label": "Message",
            "persistent-hint": "",
            "placeholder": "Do you have any feedback for this release?",
            "rows": "4"
          },
          model: {
            value: _vm.formValues.message,
            callback: function callback($$v) {
              _vm.$set(_vm.formValues, "message", $$v);
            },
            expression: "formValues.message"
          }
        }, 'v-textarea', _vm.veeValidate('Message', ''), false))], 1), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-btn', {
          staticClass: "mr-2 text-transform-none",
          attrs: {
            "disabled": _vm.updateLoading,
            "color": "primary",
            "text": ""
          },
          on: {
            "click": function click($event) {
              _vm.openUpdateFeedbackForm = false;
            }
          }
        }, [_vm._v(" Cancel ")]), _c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "loading": _vm.updateLoading,
            "outlined": _vm.$vuetify.theme.dark,
            "color": "primary",
            "depressed": ""
          },
          on: {
            "click": _vm.updateFeedback
          }
        }, [_vm._v(" Update ")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.openUpdateFeedbackForm,
      callback: function callback($$v) {
        _vm.openUpdateFeedbackForm = $$v;
      },
      expression: "openUpdateFeedbackForm"
    }
  }), _c('Modal', {
    on: {
      "close": function close($event) {
        _vm.openFlaggingConfirmModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function fn() {
        return [_c('v-row', [_c('v-col', {
          staticClass: "mt-4 font-size-h3 bold-text",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Confirm Flagging ")]), _c('v-col', {
          staticClass: "bodyFont",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Are you sure you want to flag this feedback? ")]), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "disabled": _vm.feedbackLoading,
            "color": "primary",
            "text": ""
          },
          on: {
            "click": function click($event) {
              _vm.openFlaggingConfirmModal = false;
            }
          }
        }, [_vm._v(" Cancel ")]), _c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "loading": _vm.feedbackLoading,
            "color": "primary",
            "depressed": ""
          },
          on: {
            "click": function click($event) {
              return _vm.updateStatus();
            }
          }
        }, [_vm._v(" Yes ")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.openFlaggingConfirmModal,
      callback: function callback($$v) {
        _vm.openFlaggingConfirmModal = $$v;
      },
      expression: "openFlaggingConfirmModal"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }